import React from "react";

import SEO from "@src/components/SEO";
import { StridePage } from "@src/components/dojo-tutor/lp/StridePage";

const STRIDE_DESCRIPTION =
  "Short, daily 1-on-1 sessions with the same certified teacher add 3 to 15 months of extra learning in a single school year. From $22 a class.";

const StrideRoute: React.FC = () => (
  <>
    <SEO
      title="Stride - Daily 1-on-1 Tutoring That Doubles Progress"
      description={STRIDE_DESCRIPTION}
      currentPath="/stride/"
    />
    <StridePage />
  </>
);

export default StrideRoute;
